import { BaseFieldRenderer } from './base-field-renderer';
import { TextFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class TextFieldRenderer extends BaseFieldRenderer<TextFieldJsonData> {
    protected override get defaultData(): TextFieldJsonData {
        return {
            id: '',
            type: 'text',
            label: TranslateUtils.TEXT_FIELD.LABEL,
            placeholder: TranslateUtils.TEXT_FIELD.PLACEHOLDER,
            description: '',
            required: false,
            hiddenLabel: false
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: TextFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'text';
        input.maxLength = 500;

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
